import renderPublicInformationSubmodelPdf from "./public-information/renderPublicInformationSubmodelPdf";
// import renderCarbonFootprintPdf from "./carbon-footprint/renderCarbonFootprintPdf";
import renderDefaultSubmodelPdf from "./default/renderDefaultSubmodelPdf";

// Registry by idShort
const pdfRegistryByIdShort = {};

// Registry by semanticId
const pdfRegistryBySemanticId = {
  "https://lorenz-meters.de/public/1/0/PublicInformation": renderPublicInformationSubmodelPdf,
  "0173-1#01-AHE712#001": renderDefaultSubmodelPdf,
};

export function getPdfRendererForSubmodel(submodel) {
  if (!submodel) return null;

  const idShort = submodel.idShort;
  const semanticId = submodel.semanticId?.keys?.[0]?.value;

  // Highest priority: idShort match
  if (pdfRegistryByIdShort[idShort]) {
    return pdfRegistryByIdShort[idShort];
  }

  // Second priority: semanticId match
  if (semanticId && pdfRegistryBySemanticId[semanticId]) {
    return pdfRegistryBySemanticId[semanticId];
  }

  return null;
}
